import React, { useEffect, useState } from "react";
import { APP_VERSION } from "../../version";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import "../../src/style.css";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
// import Navbar from "./Navbar";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import NightlightIcon from "@mui/icons-material/Nightlight";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import CallIcon from "@mui/icons-material/Call";

import "../../Switcher.scss";
import Cps from "../../pages/Cps";
import Cc from "../../pages/Cc";
import { api } from "../../mockData";
import LiveCall from "../../pages/LiveCall";

// Custom inline SVG — superadmin avatar. King-with-crown silhouette: an
// ornate 5-peak crown with gems on every peak sitting on the head of a
// regal figure with broad robed shoulders, V-collar cape detail, and a
// round chest medallion. Communicates "superadmin / monarch / supreme
// authority" without ambiguity.
const AdminKingIcon = ({ size = 36, color = "#fff", accent = "#f5751D" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* Crown — 5-peak silhouette, center peak highest. Outer rim only,
        with the area below the peaks forming the band. */}
    <path
      d="M9 30
         L13 16 L19 24
         L24 12 L29 22
         L32 6  L35 22
         L40 12 L45 24
         L51 16 L55 30
         L55 32 L9 32 Z"
      fill={color}
    />
    {/* Crown band horizontal stripe — adds the metallic-band detail */}
    <rect x="9" y="29.5" width="46" height="2.5" fill={accent} opacity="0.85" />
    {/* Gems on every peak — alternating sizes, with white outline so
        they pop against the dark avatar background. */}
    <circle cx="13" cy="19" r="2.3" fill={accent} stroke={color} strokeWidth="0.7" />
    <circle cx="24" cy="15" r="2.5" fill={accent} stroke={color} strokeWidth="0.7" />
    <circle cx="32" cy="9"  r="3.2" fill={accent} stroke={color} strokeWidth="0.8" />
    <circle cx="40" cy="15" r="2.5" fill={accent} stroke={color} strokeWidth="0.7" />
    <circle cx="51" cy="19" r="2.3" fill={accent} stroke={color} strokeWidth="0.7" />

    {/* Head — sits directly under the crown, sized for a regal proportion */}
    <circle cx="32" cy="42" r="8" fill={color} />

    {/* Royal shoulders / robe — wider and more imposing than a
        regular figure to suggest a king's mantle. */}
    <path
      d="M8 64 c0 -10 8 -16 24 -16 s 24 6 24 16 H8 z"
      fill={color}
    />
    {/* Cape V-opening at the chest — shadow tone gives the cloth depth */}
    <path
      d="M24 49 L32 60 L40 49 L37 64 L27 64 Z"
      fill="rgba(0,0,0,0.25)"
    />
    {/* Round royal medallion on the chest — orange to echo the crown gems */}
    <circle cx="32" cy="55" r="3.2" fill={accent} stroke={color} strokeWidth="0.9" />
  </svg>
);

function Header({ colorThem, handleClick }) {
  const [selectedValue, setSelectedValue] = useState(""); // State to hold the selected value
  const state = useSelector((state) => state?.user?.user);
  const user = JSON.parse(localStorage.getItem("admin"));
  const [pageRedirect, setPageRedirect] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state;

  const handleSelect = (eventKey) => {
    // When a Dropdown.Item is clicked, update the selected value
    setSelectedValue(eventKey);
  };

  const logout = async () => {
    // let data = JSON.stringify({
    //   "user_uuid": user?.user_uuid
    // });
    const token = JSON.parse(localStorage.getItem("admin"));
    const config = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.access_token} `,
    };
    const { data } = await axios.post(
      `${api.dev}/api/logout`,
      {},
      {
        headers: config,
      }
    );
    if (data?.status === 200) {
      toast.info(data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
      });
      localStorage.removeItem("theme-color");
      localStorage.removeItem("admin");
      navigate("/");
    }
  };

  useEffect(() => {
    let activityTimeout;

    const resetActivityTimeout = () => {
      clearTimeout(activityTimeout);
      activityTimeout = setTimeout(() => {
        localStorage.removeItem("theme-color");
        localStorage.removeItem("admin");
        setPageRedirect(true);
      }, 3600 * 3000); // 1 hour
    };

    const handleUserActivity = () => {
      resetActivityTimeout();
    };

    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keypress", handleUserActivity);

    resetActivityTimeout(); // Initialize activity timeout on component mount

    return () => {
      clearTimeout(activityTimeout); // Cleanup event listeners and timeout on component unmount
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keypress", handleUserActivity);
    };
  }, []); // Empty dependency array to ensure the effect runs only once on component mount

  useEffect(() => {
    if (pageRedirect) {
      // Redirect to the login page
      navigate("/login");
    }
  }, [pageRedirect]); // Redirect when pageRedirect changes

  useEffect(() => {
    if (selectedValue === "Manage") {
      navigate("/manage");
    }
  }, [selectedValue]); // This effect runs whenever selectedValue changes

  return (
    <>
      <div className={`App ${colorThem} `}>
        <div className="contant_box">
          <Box sx={{ flexGrow: 1 }} className={`App ${colorThem} manage_boxx`}>
            <AppBar
              position="static"
              className="manage_top_header1"
            // style={{backgroundColor:"#fff"}}
            >
              <Box className="manage_mobile_logo d-lg-none d-md-none d-sm-block d-block">
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1, }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <a
                    href="/admin_portal"
                    className="mobile_logo_center tellipsis-logo-wrap"
                  >
                    {colorThem === "theme_white" ? (
                      <>
                        {" "}
                        <img
                          src="/img/logo_white11.png"
                          alt="Manage Logo"
                          className="img-fluid d-block"
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    ) : (
                      <>
                        <img
                          src="/img/logo_white11.png"
                          alt="Manage Logo"
                          className="img-fluid d-block"
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                    <span className="tellipsis-version-badge">{APP_VERSION}</span>
                  </a>
                </Typography>
              </Box>

              <Toolbar>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ flexGrow: 1 }}
                  className="d-flex align-items-center d-block logo_image d-lg-block d-md-block d-sm-none d-none"
                >
                  <a href="/admin_portal" className="tellipsis-logo-wrap">
                    {colorThem === "theme_white" ? (
                      <>
                        {" "}
                        <img
                          src="/img/logo_white11.png"
                          alt="Manage Logo"
                          className="img-fluid d-block admin_logo"
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    ) : (
                      <>
                        <img
                          // src="/img/logo-4-edit-1.png"
                          src="/img/logo_white11.png"
                          alt="Manage Logo"
                          className="img-fluid d-block admin_logo"
                          style={{ cursor: "pointer" }}
                        />
                      </>
                    )}
                    <span className="tellipsis-version-badge">{APP_VERSION}</span>

                  </a>
                </Typography>

                <div className="manage_rgiht_bdr d-flex align-items-center justify-content-between me-lg-0 me-md-0 m-auto">
                  <Box className="header_cps">


                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      className="manage_call"
                    >
                      <CallIcon className="call_icon" />
                      <LiveCall />
                      Live
                      {/* <LiveCall /> */}
                    </IconButton>
                  </Box>

                  <div className="theme_options">
                    {colorThem === "theme_white" ? (
                      <>
                        <Tooltip
                          title="Light Theme"
                        >
                          <IconButton onClick={() => handleClick("theme_blue")}>
                            {" "}
                            <DarkModeIcon
                              id="theme_white"
                              className={`${colorThem === "theme_white" ? "active" : ""
                                }`}
                            />
                          </IconButton>
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip
                          title="Dark Theme"
                        >
                          <IconButton
                            onClick={() => handleClick("theme_white")}
                          >
                            {" "}
                            <NightlightIcon
                              id="theme_blue"
                              style={{ color: "#f5751D " }}
                              className={`${colorThem === "theme_white" ? "active" : ""
                                } fa-solid fa-moon`}
                            />
                          </IconButton>
                        </Tooltip>{" "}
                      </>
                    )}
                  </div>

                  <div className="dshbrd_hdr_icon">
                    <ul>
                      <li>
                        <ul className="hdr_profile">
                          <li>
                            <Tooltip title={user?.user_name || "Administrator"} arrow>
                              <Avatar
                                sx={{
                                  width: 46,
                                  height: 46,
                                  // Deep teal-green gradient — admin's brand
                                  // dark color, visually distinct from the
                                  // user portal's orange operator avatar so
                                  // role is unambiguous at a glance.
                                  background:
                                    "linear-gradient(135deg, #0a140e 0%, #1f3328 100%)",
                                  color: "#fff",
                                  border: "2px solid #fff",
                                  boxShadow:
                                    "0 2px 12px rgba(10, 20, 14, 0.45)",
                                  cursor: "default",
                                  // Push the SVG nearly edge-to-edge so the
                                  // crown reads at full strength even at
                                  // header-thumbnail size.
                                  "& > svg": { width: "86%", height: "86%" },
                                }}
                              >
                                <AdminKingIcon color="#fff" accent="#f5751D" />
                              </Avatar>
                            </Tooltip>

                            <div className="profile_name">
                              <b>{user?.user_name}</b>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <Tooltip title="Logout">
                    <IconButton
                      size="large"
                      aria-label="account of current user"
                      aria-controls="menu-appbar"
                      aria-haspopup="true"
                      style={{ paddingRight: "0" }}
                      onClick={logout}
                    >
                      <PowerSettingsNewIcon className="call_icon " />
                    </IconButton>
                  </Tooltip>
                </div>
              </Toolbar>
            </AppBar>
            {/* <!--navbar-sec--> */}
            {/* <Navbar selectedValue={selectedValue}/> */}
          </Box>
        </div>
      </div>
    </>
  );
}

export default Header;
